import { readonly, shallowRef, type ComputedRef, type InjectionKey, type Ref } from 'vue';

export type ModalContext = {
    dialog: Readonly<Ref<HTMLDialogElement | null>>;
    active: ComputedRef<boolean>;
};

export const modalContextKey: InjectionKey<ModalContext> = Symbol('ideo-modal-context');

const dialogs: HTMLDialogElement[] = [];
const currentModal = shallowRef<HTMLDialogElement | null>(null);

export const activeModal = readonly(currentModal);

function refreshActiveModal()
{
    currentModal.value = dialogs.findLast(dialog => dialog.open && dialog.isConnected) ?? null;
}

function onClose(event: Event)
{
    const dialog = event.currentTarget as HTMLDialogElement;

    if (!dialog.open)
        unregisterModal(dialog);
}

export function registerModal(dialog: HTMLDialogElement)
{
    if (!dialog.open || !dialog.isConnected)
        return;

    unregisterModal(dialog);
    dialogs.push(dialog);
    dialog.addEventListener('close', onClose);
    refreshActiveModal();
}

export function unregisterModal(dialog: HTMLDialogElement)
{
    const index = dialogs.indexOf(dialog);

    if (index !== -1)
        dialogs.splice(index, 1);

    dialog.removeEventListener('close', onClose);
    refreshActiveModal();
}
